import { RetrofitNameSchema, type RetrofitName } from '@/shared/types/assessment.types'
import type { Retrofit } from '@/shared/types/custom-assessment-input.types'

/**
 * All possible retrofit names extracted from the RetrofitNameSchema
 */
const ALL_RETROFIT_NAMES = RetrofitNameSchema.options

/**
 * Creates a default retrofit object with undefined values for all optional fields
 */
const createDefaultRetrofit = (retrofitName: RetrofitName): Retrofit => {
  return {
    retrofitName,
    powerInKw: undefined,
    componentAreaInSqm: undefined,
    totalCostsInCt: undefined,
    insulationThicknessInMm: undefined,
  }
}

/**
 * Initializes all possible retrofits with default values,
 * then merges with existing retrofit data
 */
export const initializeRetrofits = (existingRetrofits: Retrofit[]): Retrofit[] => {
  // Create a map of existing retrofits by name for easy lookup
  const existingMap = new Map(existingRetrofits.map(r => [r.retrofitName, r]))

  // Create all retrofits with defaults, using existing data when available
  return ALL_RETROFIT_NAMES.map(retrofitName => {
    const existing = existingMap.get(retrofitName)
    return existing || createDefaultRetrofit(retrofitName)
  })
}
